import { useContext } from 'solid-js';
import { EditorialCard } from '../../editorial-card/editorial-card';
import { EventListCardData } from '../../event/event-types';
import { AppContext } from '../../../app-context-provider/app-context-provider';
import { isPastEvent } from './is-past-event';
import { getEventCardOverrides } from './event-card-overrides';

export const createGroupedEventCard = (props: { event: EventListCardData }) =>
    createEventCard(props);

export const createEventCard = (props: { event: EventListCardData }) => {
    const { localize, siteInfo } = useContext(AppContext);

    return (
        <EditorialCard
            data={props.event}
            myContentType="event"
            stale={isPastEvent(props.event)}
            {...getEventCardOverrides(props.event, localize, siteInfo.key)}
        />
    );
};
